import React from 'react';
import { getAPIData, getAPIDataParams } from '../utils/apiFunction';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import dayjs from 'dayjs';

const SalesOrderSelect = (props) => {
    const [myob, setMyob] = React.useState([]);
    const [value, setValue] = React.useState(props.state);
    const [inputValue, setInputValue] = React.useState('');

    const filterVals = (lists) => {
        var list = lists;
        setMyob(list.sort((a, b) => {
            return a.myobid > b.myobid ? 1 : -1;
        }))
    }

    React.useEffect(() => {
        if (props.myobId) {
            var est = myob.find((dr) => { return (dr.id === props.myobId) });
            props.setState(est);
            setValue(est);
        }
    }, [myob, props.myobid])

    React.useEffect(() => {
        const fetchData = async () => {
            props.setSearching(true);

            try {
                let url = '/SalesOrder/GetForCreditMemo';
                if (props.lotSerialNbr !== undefined && props.lotSerialNbr !== null) {
                    url += '?filter=' + props.lotSerialNbr;
                }

                await getAPIData(url, filterVals);
            } catch (err) {
                console.error('Error fetching sales orders for credit memo', err);
            } finally {
                props.setSearching(false);
            }
        };
        fetchData();
    }, [props.lotSerialNbr]); // keep dependency array    

    return (
        <Autocomplete
            value={value}
            disabled={props.disabled}
            onChange={(event, newValue) => {
                props.setState(newValue);
                setValue(newValue);
                if (typeof props.onSelected === 'function') {
                    props.onSelected(newValue);
                }
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            getOptionLabel={(option) => (option?.myobid + ' - ' + option?.customer?.name + ' (' + dayjs(option?.shipmentDate).format('DD/MM/YYYY') + ')')}
            disablePortal
            id="salesorderid"
            options={myob}
            fullWidth
            sx={{ width: '80%' }}
            renderInput={(params) => <TextField {...params} label="Sales Order" fullWidth />}
        />
    );
}
export default SalesOrderSelect;